export default "__VITE_ASSET__f502691b__"